<template>
<form @submit.prevent="submit" autocomplete="off">
    <ui-alert type="error" v-for="e,index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>
    <fieldset>
        <legend>Podstawowe dane</legend>

        <ui-textbox label="Twoja nazwa tego konta" name="name" type="text" v-model="item.name" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz nazwę"></ui-textbox>

        <ui-textbox label="Adres e-mail z jakiego będą wychodzić wiadomości" name="from_address" type="text" v-model="item.from_address" validation-rules="required|email" :validation-messages="errorMessages" placeholder="Adres e-mail z jakiego będą wychodzić wiadomości"></ui-textbox>

        <ui-textbox label="Nazwa wysyłającego wiadomości" name="from_name" type="text" v-model="item.from_name" validation-rules="required" :validation-messages="errorMessages" placeholder="Nazwa wysyłającego wiadomości"></ui-textbox>


    </fieldset>

    <fieldset>
        <legend>Dane konta smtp</legend>
        <ui-textbox label="Serwer" name="host" type="text" v-model="item.host" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz nazwę serwera np. mail.twoja-domena.com"></ui-textbox>
        <ui-textbox label="Port" name="port" type="number" v-model="item.port" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz nazwę serwera np.: mail.twoja-domena.com"></ui-textbox>


        <ui-textbox label="Nazwa użytkownika" name="username" type="text" v-model="item.username" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz nazwę użytkownika np. user@mail.twoja-domena.com"></ui-textbox>
        <ui-textbox label="Hasło użytkownika" name="password" type="text" v-model="item.password" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz hasło użytkownika"></ui-textbox>

        <ui-textbox label="Szyfrowanie" name="encryption" type="text" v-model="item.encryption" placeholder="Wpisz szyfrowanie np.: tls" help-text="Zostaw pole puste lub wpisz tls"></ui-textbox>
    </fieldset>

    <fieldset>
        <legend>Limit wysyłania</legend>
        <ui-textbox label="Limit wysyłanych wiadomości za jednym razem" name="limit" type="number" v-model="item.limit" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz limit wysyłanych wiadomości np.: 100" help-text="Warto ustawić tą wartość na małą liczbę np. 100 i zwiększać gdy nie ma żadnych kłopotów"></ui-textbox>
    </fieldset>


    <div class="form-actions">
        <ui-button color="primary">{{ item.id ? 'Aktualizuj' : 'Dodaj' }}</ui-button>
    </div>
</form>

</template>

<script>
import Loading from '../../mixins/Loading'
import Notify from '../../mixins/Notify'
import FormErrors from '../../mixins/FormErrors'
import Utils from '../../services/Utils'

import Accounts from './../../services/Accounts'

export default {
  mixins: [Loading, Notify, FormErrors],
  props: ['item'],
  data () {
    return {
      errors: [],
      title: 'Dodaj konto do wysyłania',
      action: 'Dodaj konto do wysyłania',
      errorMessages: Utils.errorMessages(['required', 'min', 'numeric', 'email'])
    }
  },
  mounted () {
    if (this.item.id) {
      this.title = 'Aktualizuj konto do wysyłania'
      this.action = 'Aktualizuj konto do wysyłania'
    }
  },
  methods: {
    resetForm () {
      this.item = Accounts.getBaseItem()
    },
    error (err) {
      this.errors = this.getResponseErrors(err)
      this.notify('Wystąpiły błędy')
    },
    success (res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.$emit('accounts.update', this.item)
          this.notify('Zmieniłeś konto do wysyłania')
          this.$router.push({name: 'admin.accounts.show', params: {id: this.item.id}})
        }
      } else {
        if (res.status === 201) {
          this.$emit('accounts.create', this.item)
          this.notify('Dodałeś konto do wysyłania')
          this.$router.push({name: 'admin.accounts.show', params: {id: res.data.item.id}})
        }
      }
    },
    submit () {
      this.errors = []
      window.scrollTo(0, 0)

      let item = Object.assign({}, this.item)
      if (this.item.id) {
        item.id = this.item.id
      }

      if (this.item.id) {
        Accounts.update(item).then(this.success, this.error)
      } else {
        Accounts.create(item).then(this.success, this.error)
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// Form.vue?73037041